import { AbstractTracker } from '../../../internal/platformMetrics/aggregators/AbstractTracker';
class Counter extends AbstractTracker {
    track(id) {
        var _this_data, _id;
        var _;
        (_ = (_this_data = this.data)[_id = id]) !== null && _ !== void 0 ? _ : _this_data[_id] = 0;
        this.data[id]++;
    }
}
export { Counter as default };

//# sourceMappingURL=Counter.js.map